"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isExternalLink = isExternalLink;
exports.normalizeLink = normalizeLink;

var _reactGlobalConfiguration = _interopRequireDefault(require("react-global-configuration"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isExternalLink() {
  var uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = uri.trim().replace(/\/$/, '');

  if (/^(https?|mailto|tel):/g.test(value)) {
    return true;
  }

  return false;
}

function normalizeLink(link) {
  var API_URL = _reactGlobalConfiguration.default.get('API_URL');

  if (/^\//g.test(link)) {
    return "".concat(API_URL).concat(link);
  }

  return link;
}